/** URL modal opened after a Super Sub signup or upgrade. */
export const SUPER_SUB_TELEGRAM_MODAL = "super-sub-telegram";

export function hrefWithSuperSubTelegramModal(pathname = "/library") {
  return `${pathname}?modal=${SUPER_SUB_TELEGRAM_MODAL}`;
}
